import React, { useState, useEffect } from "react";

import { formatName, abbreviateNumber } from "helpers/miscHelpers";

import MultiLineChart from "./CoronaChart";
import { StyledUI, StyledOptionsMenu, StyledGraphHolder } from "./styles";

const CoronaGraphs = (props) => {
  const { chartType, initialStates = [], loadedData, setChartType } = props;

  const [graphStates, setGraphStates] = useState(initialStates);
  const [dateCount, setDateCount] = useState(30);
  const [showSMA, setShowSMA] = useState(1);
  // const [showBBands, setShowBBands] = useState(0);

  function handleStateChange(e, index) {
    const val = e.target.value;
    const curStates = Array(...graphStates);
    curStates[index] = val === "Select" ? "" : val;

    setGraphStates(curStates);
  }

  function clearLoc(index) {
    const curStates = Array(...graphStates);
    curStates[index] = "";
    setGraphStates(curStates);
  }

  const convertToGraphDataUS = (data, states) => {
    const dateFields = Object.keys(data[0].timeline[`${chartType}`]).slice(
      -dateCount
    );

    const statesData = data.filter((c) => states.includes(c.name));

    const output = dateFields.map((df, i) => {
      const pointData = { name: df };
      const stateData = statesData.map((sd) => ({
        [`${sd.name}`]: sd.timeline[`${chartType}`][df],
      }));

      return Object.assign(pointData, ...stateData);
    });

    return output;
  };

  return (
    <StyledUI>
      <StyledGraphHolder>
        <MultiLineChart
          key="main"
          aspectRatio={0.6}
          data={convertToGraphDataUS(loadedData, graphStates)}
          xField="name"
          yFields={graphStates}
          scale="linear"
          showSMA={showSMA}
          tooltipFormatter={
            ["casesPer100k", "deathsPer100k"].includes(chartType)
              ? (y) => Number(y).toFixed(3)
              : (d) => abbreviateNumber(d, 2)
          }
          yAxisLabel={
            chartType === "positiveIncrease"
              ? "New Positive Tests"
              : chartType === "negativeIncrease"
              ? "New Negative Tests"
              : chartType === "totalTestResults"
              ? "Total Tests"
              : chartType === "totalTestResultsIncrease"
              ? "New Tests"
              : chartType === "hospitalizedIncrease"
              ? "New Hospitalizations"
              : chartType === "hospitalizedCurrently"
              ? "Currently Hospitalized"
              : chartType === "hospitalizedCumulative"
              ? "Total Hospitalized (Cumulative)"
              : chartType === "deathIncrease"
              ? "New Deaths"
              : chartType === "death"
              ? "Total Deaths"
              : formatName(chartType)
          }
          yTickFormatter={
            ["casesPer100k", "deathsPer100k"].includes(chartType)
              ? (y) => Number(y).toFixed(3)
              : (d) => abbreviateNumber(d, 2)
          }
        />
      </StyledGraphHolder>

      <StyledOptionsMenu>
        <h3 className="control-title">Graph Controls</h3>

        <div className="main-options">
          <div className="opt">
            <label htmlFor="dd_data">
              Data Type:
              <select
                onChange={(e) => setChartType(e.target.value)}
                className="custom-select"
                // style={{ maxWidth: "180px" }}
                defaultValue={chartType}
                id="dd_data"
              >
                <option value="totalTestResults">Total Tests</option>
                <option value="totalTestResultsIncrease">New Tests</option>
                <option value="positive">Positive Tests</option>
                <option value="positiveIncrease">New Positive Tests</option>
                <option value="negative">Negative Tests</option>
                <option value="negativeIncrease">New Negative Tests</option>
                <option value="hospitalizedCumulative">
                  Hospitalized (Cumulative)
                </option>
                <option value="hospitalizedCurrently">
                  Hospitalized (Current)
                </option>
                <option value="hospitalizedIncrease">Hospitalized (New)</option>
                <option value="death">Deaths</option>
                <option value="deathIncrease">New Deaths</option>
              </select>
            </label>
          </div>

          <div className="opt">
            <label htmlFor="dd_days">
              Day Count:
              <select
                onChange={(e) => setDateCount(e.target.value)}
                className="custom-select"
                // style={{ maxWidth: "180px" }}
                defaultValue={dateCount}
                id="dd_days"
              >
                {[300, 150, 120, 100, 75, 50, 40, 30, 20, 10, 5].map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="opt">
            <label htmlFor="dd_sma">
              7-day SMA
              <select
                onChange={(e) => setShowSMA(Number(e.target.value))}
                className="custom-select"
                defaultValue={showSMA}
                id="dd_sma"
              >
                <option value={1}>Show</option>
                <option value={0}>Hide</option>
              </select>
            </label>
          </div>
        </div>

        <div className="loc-options">
          <div>
            <p className="statesSelectLabel">Select States:</p>
            <div className="statesBox">
              {graphStates.map((state, i) => (
                <div className="select-row" key={`dropdown_${i}`}>
                  <button type="button" onClick={() => clearLoc(i)}>
                    clear
                  </button>
                  <select
                    onChange={(e) => handleStateChange(e, i)}
                    className="custom-select mb-2 mx-1 mx-lg-0"
                    value={state}
                  >
                    <option value="">Select</option>
                    {loadedData.map((c, z) => (
                      <option key={`sel-${i}-${z}`} value={c.name}>
                        {formatName(c.name)}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
          </div>
        </div>
      </StyledOptionsMenu>
    </StyledUI>
  );
};

export default CoronaGraphs;
